import axiosClient from './axiosClient'
import urlApi from './url'
const campaignApi = {
  get: (params) => {
    return axiosClient.get(`${urlApi.campaignApi.campaign}`, { params })
  },
  delete: (campaignId) => {
    return axiosClient.delete(`${urlApi.campaignApi.campaign}/${campaignId}`)
  },
}

export default campaignApi
